var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5547 3.5625H3.44531C3.25114 3.5625 3.09375 3.40511 3.09375 3.21094V2.29688C3.09375 1.44254 3.78629 0.75 4.64062 0.75H13.3594C14.2137 0.75 14.9062 1.44254 14.9062 2.29688V3.21094C14.9062 3.40511 14.7489 3.5625 14.5547 3.5625Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1016 4.6875H1.89844C0.851625 4.6875 0 5.53913 0 6.58594V13.1953C0 14.2421 0.851625 15.0938 1.89844 15.0938H3.09375V12.2812C3.09375 10.8855 4.22926 9.75 5.625 9.75H12.375C13.7707 9.75 14.9062 10.8855 14.9062 12.2812V15.0938H16.1016C17.1484 15.0938 18 14.2421 18 13.1953V6.58594C18 5.53913 17.1484 4.6875 16.1016 4.6875ZM3.3757 8.90625C2.90971 8.90625 2.53178 8.5285 2.53178 8.0625C2.53178 7.5965 2.90936 7.21875 3.37535 7.21875H3.3757C3.8417 7.21875 4.21945 7.5965 4.21945 8.0625C4.21945 8.5285 3.8417 8.90625 3.3757 8.90625Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 11.4375H5.625C5.159 11.4375 4.78125 11.8153 4.78125 12.2812V15.0938V16.2188C4.78125 16.6847 5.159 17.0625 5.625 17.0625H12.375C12.841 17.0625 13.2188 16.6847 13.2188 16.2188V15.0938V12.2812C13.2188 11.8153 12.841 11.4375 12.375 11.4375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIcon);
export default __webpack_public_path__ + "static/media/print_icon.a10dc7c1a8f6d406a27f83d9a7892b71.svg";
export { ForwardRef as ReactComponent };